import { useEffect } from "react"

import Router from "~/router"
import Page from "~/v2/components/page"
import { VaasProvider } from "~/v2/providers/vaas"

const Vaas = ({
  routes = [],
  ...rest
}: {
  routes?: unknown[]
  [key: string]: unknown
}) => {
  useEffect(() => {
    document.title = "VAAS"
  }, [])

  return (
    <Page>
      <VaasProvider>
        <div className="flex h-full w-full flex-col">
          <Router routes={routes} {...rest} />
        </div>
      </VaasProvider>
    </Page>
  )
}

export default Vaas
